import React, { useState,useEffect } from 'react';
import { Button, Checkbox, Countdown, InfoBox, Input } from 'components';
import { Modal, Form, message, Row, Col } from 'antd';
import '../basket-summary.less'
import 'components/Modal/modal.less'
import { sendOtp, validateOtp} from 'services/omcc.service';
import { useSelector} from 'react-redux';
import { customMessages } from 'utils';
const ConfirmModal = (props) => {
  const [modalConfirm, setModalConfirm] = useState(props.showModal);
  
  const {loading, setLoading} = useSelector(state=>state.loader);
  const [otpCounterStarted, setOtpCounterStarted] = useState(false);
  const [currentOtp, setCurrentOtp] = useState();
  const [purchaseType, setpurchaseType] = useState(props.purchaseType);

  useEffect(() => {
    if (props.showModal)
    {
      onSendOtp ();
    }
  }, [props.showModal]);


  function onConfirm() {
    if (!otpCounterStarted)
    {
      onSendOtp();
    }
    else{
      // OTP boş veya null ise kredi kartı akışına geçilmemeli
      if (!currentOtp || currentOtp.trim() === '') {
        message.error('Lütfen doğrulama kodunu giriniz.');
        return;
      }
      validateOtp(currentOtp)
        .then((result) => {
          props.onConfirmSale();
          props.toggleModal(false);
        }).catch((response) => {
          message.error(customMessages.getMessage(response.responseCode));
          // Modal açık kalır, kullanıcı tekrar OTP girebilir
        });
    }
  }


  function onSendOtp ()
  {
    sendOtp(props?.selectedPackage?.offerId,props?.purchaseType).then(() => {
        setOtpCounterStarted(true);
        setCurrentOtp("");
    }).catch((err) => {
      props.toggleModal(false);
      message.error(customMessages.getMessage(err.responseCode));
   });
  }

  return (
      <React.Fragment>
        
        <Modal
            title="Satın Alım İşlemini Onayla"
            visible={props.showModal}
            className="modal-purchase-confirm"
            onCancel={ () => props.toggleModal(false) }
            footer={[
              <div className="modal-action">
                <Button
                  shape="round"
                  type="ghost"
                  onClick={ () => {
                    props.toggleModal(false)
                  } }
                >
                  Vazgeç
                </Button>
                <Button loading={loading}  onClick={ () => {
                    onConfirm();
                  } } key="confirm" type="primary">
                  {otpCounterStarted ? 'Onayla':'Tekrar Gönder'} 
                </Button>
              </div>
            ]}>
            <span className="highlighted">{props?.selectedPackage?.name}</span>
            <p className="info-text">İşlemi onaylamanız halinde seçtiğiniz ödeme yöntemi ile <strong>{props?.selectedPackage?.prize} TL</strong> tutar tahsil edilecektir. <br/> Onaylamak için telefonunuza gelen doğruluma kodunu giriniz.</p>
            <Row justify="center">
            <Col
              span={24}
              className="flex-center-center margin-bottom-spacing-s"
            >
               {<Countdown changedCounter={setOtpCounterStarted} startCounter={otpCounterStarted} />}
            </Col>
            </Row>
                <Input autoComplete="off" style={{ width: '100%' }}  value={currentOtp} onChange={(e) => setCurrentOtp(e.target.value)}
                        maxLength={6}/>
          </Modal>
     </React.Fragment>
  )
}

export default ConfirmModal